import React, { ChangeEvent } from 'react';
import moment from 'moment';
import { Input } from '@99designs/emu';
import { useFormatDate } from '@99designs/i18n';
import { ObservableField as Field, useForm } from '../../ObservableForm';
import { DateFieldFragment } from './DateField.generated';

export type Props = DateFieldFragment;

export const DATE_FORMAT = 'yyyy-MM-DD';

function formatDate(date: string) {
    return moment(date).format(DATE_FORMAT);
}

export function Edit({ id: name, label, subtext, required }: Props) {
    const form = useForm();

    return (
        <Field
            form={form}
            name={name}
            title={label}
            required={required ?? false}
            render={() => {
                const date = form.get(name);
                return (
                    <Input
                        id={name}
                        label={subtext ?? ''}
                        type="date"
                        onChange={(event: ChangeEvent<HTMLInputElement>) =>
                            form.set(name, event.target.value)
                        }
                        value={date ? formatDate(date) : undefined}
                    />
                );
            }}
        />
    );
}

export function View(props: Props) {
    const formatDate = useFormatDate('longDate');
    return <>{formatDate(props.dateValue)}</>;
}

export function HasValue({ dateValue }: Props): boolean {
    return !!dateValue;
}

export function getValue({ dateValue }: Props) {
    return dateValue;
}
